// extracted by mini-css-extract-plugin
export default {"products":"ProductsList_products__3LmPr","productsList":"ProductsList_productsList__dmPVi","error":"ProductsList_error__Ps6TV"};